import * as React from 'react'

import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import isNil from 'lodash/isNil'

import { observer } from 'mobx-react'

import { convertDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import DescriptionItem from 'modules/automations/components/AutomationHistory/entries_table/entry_row/action/description_item'
import ExpandableBlock from 'modules/automations/components/AutomationHistory/entries_table/entry_row/action/expandable_block'
import { ExecutionHistoryAggregateActionTaskState } from 'modules/automations/lib/enums'
import { ExecutionHistoryAggregateActionTask } from 'modules/automations/store/models/ExecutionHistoryEntry'

interface StateBadgeProps {
  state: ExecutionHistoryAggregateActionTaskState
}

function StateBadge({ state }: StateBadgeProps) {
  switch (state) {
    case ExecutionHistoryAggregateActionTaskState.Running:
      return <Tag type="champagne">{i18n.t('automations.history.task_state.running')}</Tag>
    case ExecutionHistoryAggregateActionTaskState.Finished:
      return <Tag type="lime">{i18n.t('automations.history.task_state.finished')}</Tag>
    case ExecutionHistoryAggregateActionTaskState.Error:
      return (
        <Tag type="radical" solid>
          {i18n.t('automations.history.task_state.error')}
        </Tag>
      )
    default:
      return <Tag type="neutral">{state}</Tag>
  }
}

function formatDate(date: string | null | undefined) {
  if (isNil(date)) {
    return undefined
  }

  return convertDate(date, 'backend_datetime', 'ui_short_with_time')
}

interface HistoryTaskProps {
  aggregateActionTask: ExecutionHistoryAggregateActionTask
}

const HistoryTask = ({ aggregateActionTask }: HistoryTaskProps) => {
  const title = (
    <Box flexDirection="row" gap="s4">
      <Box flexNoShrink>
        <StateBadge state={aggregateActionTask.state} />
      </Box>
      <Text.Normal weight="bold" size="200">
        {aggregateActionTask.name}
      </Text.Normal>
    </Box>
  )

  return (
    <ExpandableBlock title={title}>
      <DescriptionItem
        title={i18n.t('automations.history.task.started_at')}
        value={formatDate(aggregateActionTask.started_at)}
      />
      <DescriptionItem
        title={i18n.t('automations.history.task.finished_at')}
        value={formatDate(aggregateActionTask.finished_at)}
      />
    </ExpandableBlock>
  )
}

export default observer(HistoryTask)
